// CODE AUTOGENERATED BY npm run updateapi
// IF YOU MODIFY THIS FILE, MAKE SURE TO ALSO MODIFY THE updateapi SCRIPT!
// OTHERWISE YOUR CHANGES MAY BE OVERWRITTEN!
export enum AchievementTypeDto {
  TOTAL_POINTS = 'TOTAL_POINTS',
  TOTAL_CHALLENGES = 'TOTAL_CHALLENGES',
  TOTAL_JOURNEYS = 'TOTAL_JOURNEYS',
  TOTAL_CHALLENGES_OR_JOURNEYS = 'TOTAL_CHALLENGES_OR_JOURNEYS',
}

export enum LoginAudDto {
  android = 'android',
  ios = 'ios',
  web = 'web',
}

export enum LoginEnrollmentTypeDto {
  UNDERGRADUATE = 'UNDERGRADUATE',
  GRADUATE = 'GRADUATE',
  FACULTY = 'FACULTY',
  ALUMNI = 'ALUMNI',
  GUEST = 'GUEST',
}

export enum BearSlotDto {
  EYES = 'EYES',
  MOUTH = 'MOUTH',
  COLOR = 'COLOR',
  ACCESSORY = 'ACCESSORY',
}

export enum CampusEventCategoryDto {
  SOCIAL = 'SOCIAL',
  CULTURAL = 'CULTURAL',
  ATHLETIC = 'ATHLETIC',
  WELLNESS = 'WELLNESS',
  ACADEMIC = 'ACADEMIC',
  ARTS = 'ARTS',
  CAREER = 'CAREER',
  COMMUNITY = 'COMMUNITY',
  OTHER = 'OTHER',
}

export enum EventSourceDto {
  API_EVENTS = 'API_EVENTS',
  ADMIN_CREATED = 'ADMIN_CREATED',
  COMMUNITY_SUBMITTED = 'COMMUNITY_SUBMITTED',
}

export enum CheckInMethodDto {
  LOCATION = 'LOCATION',
  QR_CODE = 'QR_CODE',
  EITHER = 'EITHER',
}

export enum CampusEventCategoriesDto {
  SOCIAL = 'SOCIAL',
  CULTURAL = 'CULTURAL',
  ATHLETIC = 'ATHLETIC',
  WELLNESS = 'WELLNESS',
  ACADEMIC = 'ACADEMIC',
  ARTS = 'ARTS',
  CAREER = 'CAREER',
  COMMUNITY = 'COMMUNITY',
  OTHER = 'OTHER',
}

export enum CampusEventSourceDto {
  API_EVENTS = 'API_EVENTS',
  ADMIN_CREATED = 'ADMIN_CREATED',
  COMMUNITY_SUBMITTED = 'COMMUNITY_SUBMITTED',
}

export enum CampusEventCheckInMethodDto {
  LOCATION = 'LOCATION',
  QR_CODE = 'QR_CODE',
  EITHER = 'EITHER',
}

export enum RequestCampusEventsCategoriesDto {
  SOCIAL = 'SOCIAL',
  CULTURAL = 'CULTURAL',
  ATHLETIC = 'ATHLETIC',
  WELLNESS = 'WELLNESS',
  ACADEMIC = 'ACADEMIC',
  ARTS = 'ARTS',
  CAREER = 'CAREER',
  COMMUNITY = 'COMMUNITY',
  OTHER = 'OTHER',
}

export enum UpsertCampusEventCategoriesDto {
  SOCIAL = 'SOCIAL',
  CULTURAL = 'CULTURAL',
  ATHLETIC = 'ATHLETIC',
  WELLNESS = 'WELLNESS',
  ACADEMIC = 'ACADEMIC',
  ARTS = 'ARTS',
  CAREER = 'CAREER',
  COMMUNITY = 'COMMUNITY',
  OTHER = 'OTHER',
}

export enum UpsertCampusEventSourceDto {
  API_EVENTS = 'API_EVENTS',
  ADMIN_CREATED = 'ADMIN_CREATED',
  COMMUNITY_SUBMITTED = 'COMMUNITY_SUBMITTED',
}

export enum UpsertCampusEventCheckInMethodDto {
  LOCATION = 'LOCATION',
  QR_CODE = 'QR_CODE',
  EITHER = 'EITHER',
}

export enum ChallengeLocationDto {
  ENG_QUAD = 'ENG_QUAD',
  ARTS_QUAD = 'ARTS_QUAD',
  AG_QUAD = 'AG_QUAD',
  CENTRAL_CAMPUS = 'CENTRAL_CAMPUS',
  NORTH_CAMPUS = 'NORTH_CAMPUS',
  WEST_CAMPUS = 'WEST_CAMPUS',
  CORNELL_ATHLETICS = 'CORNELL_ATHLETICS',
  VET_SCHOOL = 'VET_SCHOOL',
  COLLEGETOWN = 'COLLEGETOWN',
  ITHACA_COMMONS = 'ITHACA_COMMONS',
  ANY = 'ANY',
}

export enum CheckInResultCheckInMethodDto {
  LOCATION = 'LOCATION',
  QR_CODE = 'QR_CODE',
}

export enum CheckInErrorCodeDto {
  EVENT_NOT_FOUND = 'EVENT_NOT_FOUND',
  EVENT_NOT_ACTIVE = 'EVENT_NOT_ACTIVE',
  EVENT_NOT_APPROVED = 'EVENT_NOT_APPROVED',
  ALREADY_CHECKED_IN = 'ALREADY_CHECKED_IN',
  OUT_OF_RADIUS = 'OUT_OF_RADIUS',
  METHOD_NOT_ALLOWED = 'METHOD_NOT_ALLOWED',
  INVALID_QR_CODE = 'INVALID_QR_CODE',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export enum ClubSubmissionCategoryDto {
  SOCIAL = 'SOCIAL',
  CULTURAL = 'CULTURAL',
  ATHLETIC = 'ATHLETIC',
  WELLNESS = 'WELLNESS',
  ACADEMIC = 'ACADEMIC',
  ARTS = 'ARTS',
  CAREER = 'CAREER',
  COMMUNITY = 'COMMUNITY',
  OTHER = 'OTHER',
}

export enum EventCategoryDto {
  FOOD = 'FOOD',
  NATURE = 'NATURE',
  HISTORICAL = 'HISTORICAL',
  RESIDENTIAL = 'RESIDENTIAL',
  LANDMARK = 'LANDMARK',
  ARTS = 'ARTS',
  ATHLETICS = 'ATHLETICS',
  LIBRARY = 'LIBRARY',
  ACADEMIC = 'ACADEMIC',
  RECREATION = 'RECREATION',
}

export enum EventTimeLimitationDto {
  LIMITED_TIME = 'LIMITED_TIME',
  PERPETUAL = 'PERPETUAL',
}

export enum EventDifficultyDto {
  Easy = 'Easy',
  Normal = 'Normal',
  Hard = 'Hard',
}

export enum FeedbackCategoryDto {
  BUG_REPORT = 'BUG_REPORT',
  SUGGESTION = 'SUGGESTION',
  GENERAL = 'GENERAL',
}

export enum QuizErrorCodeDto {
  NO_QUESTIONS = 'NO_QUESTIONS',
  ALREADY_ANSWERED = 'ALREADY_ANSWERED',
  INVALID_QUESTION = 'INVALID_QUESTION',
  INVALID_ANSWER = 'INVALID_ANSWER',
}

export enum SetAuthToOAuthProviderDto {
  apple = 'apple',
  google = 'google',
}

export enum UserEnrollmentTypeDto {
  UNDERGRADUATE = 'UNDERGRADUATE',
  GRADUATE = 'GRADUATE',
  FACULTY = 'FACULTY',
  ALUMNI = 'ALUMNI',
  GUEST = 'GUEST',
}

export enum UserAuthTypeDto {
  apple = 'apple',
  google = 'google',
  device = 'device',
}

export interface AchievementDto {
  id: string;
  eventId?: string;
  requiredPoints?: number;
  name?: string;
  description?: string;
  imageUrl?: string;
  locationType?: ChallengeLocationDto;
  achievementType?: AchievementTypeDto;
  initialOrganizationId?: string;
}

export interface AchievementTrackerDto {
  userId: string;
  progress: number;
  achievementId: string;
  dateComplete?: string;
}

export interface UpdateAchievementDataDto {
  achievement: AchievementDto;
  deleted: boolean;
}

export interface RequestAchievementDataDto {
  achievements: string[];
}

export interface RequestAchievementTrackerDataDto {
  achievements?: string[];
}

export interface LoginDto {
  idToken: string;
  noRegister: boolean;
  latF?: number;
  longF?: number;
  username?: string;
  year?: string;
  college?: string;
  major?: string;
  interests?: string;
  aud?: LoginAudDto;
  enrollmentType: LoginEnrollmentTypeDto;
}

export interface RefreshTokenDto {
  refreshToken: string;
}

export interface BearItemDto {
  id: string;
  name: string;
  slot: BearSlotDto;
  cost: number;
  assetKey: string;
  mimeType: string;
  zIndex?: number;
}

export interface PurchaseBearItemDto {
  itemId: string;
}

export interface EquipBearItemDto {
  slot: BearSlotDto;
  itemId?: string;
}

export interface PurchaseResultDto {
  success: boolean;
  newBalance: number;
  itemId: string;
}

export interface EquippedSlotDto {
  slot: BearSlotDto;
  itemId?: string;
  zIndex?: number;
}

export interface UserBearLoadoutDto {
  userId: string;
  equipped: EquippedSlotDto[];
}

export interface UserInventoryDto {
  userId: string;
  items: BearItemDto[];
  balance: number;
}

export interface RequestBearItemsDto {
  slot?: BearSlotDto;
}

export interface RequestUserInventoryDto {}

export interface RequestUserBearLoadoutDto {}

export interface UpdateBearItemsDataDto {
  items: BearItemDto[];
}

export interface UpdateUserInventoryDataDto {
  userId: string;
  items: BearItemDto[];
  balance: number;
}

export interface UpdateUserBearLoadoutDataDto {
  userId: string;
  equipped: EquippedSlotDto[];
}

export interface UpdatePurchaseResultDto {
  success: boolean;
  newBalance: number;
  itemId: string;
}

export interface AdminBearItemDto {
  id: string;
  name?: string;
  slot?: BearSlotDto;
  cost?: number;
  assetKey?: string;
  mimeType?: string;
  zIndex?: number;
  isDefault?: boolean;
}

export interface UpdateBearItemDataDto {
  bearItem: AdminBearItemDto;
  deleted: boolean;
}

export interface RequestAllBearItemsDto {}

export interface CampusEventDto {
  id: string;
  title: string;
  description: string;
  imageUrl?: string;
  startTime: string;
  endTime: string;
  allDay: boolean;
  locationName: string;
  address?: string;
  latitude: number;
  longitude: number;
  categories: CampusEventCategoriesDto[];
  tags: string[];
  source: CampusEventSourceDto;
  externalUrl?: string;
  organizerName?: string;
  registrationUrl?: string;
  checkInMethod: CampusEventCheckInMethodDto;
  pointsForAttendance: number;
  featured: boolean;
  attendanceCount: number;
  rsvpCount: number;
}

export interface RequestCampusEventsDto {
  page: number;
  limit: number;
  dateFrom?: string;
  dateTo?: string;
  categories?: RequestCampusEventsCategoriesDto[];
  search?: string;
  featured?: boolean;
}

export interface CampusEventListDto {
  events: CampusEventDto[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface RequestCampusEventDetailsDto {
  eventId: string;
}

export interface UpsertCampusEventDto {
  id?: string;
  title: string;
  description: string;
  imageUrl?: string;
  startTime: string;
  endTime: string;
  allDay?: boolean;
  locationName: string;
  address?: string;
  latitude: number;
  longitude: number;
  checkInRadius?: number;
  categories: UpsertCampusEventCategoriesDto[];
  tags: string[];
  source: UpsertCampusEventSourceDto;
  externalId?: string;
  externalUrl?: string;
  organizerName?: string;
  organizerEmail?: string;
  organizerId?: string;
  checkInMethod?: UpsertCampusEventCheckInMethodDto;
  pointsForAttendance?: number;
  featured?: boolean;
  registrationUrl?: string;
}

export interface DeleteCampusEventDto {
  eventId: string;
}

export interface RsvpCampusEventDto {
  eventId: string;
}

export interface UnRsvpCampusEventDto {
  eventId: string;
}

export interface UpdateCampusEventDataDto {
  event: CampusEventDto;
  deleted: boolean;
}

export interface CampusEventListResponseDto {
  list: CampusEventListDto;
}

export interface CompletedChallengeDto {}

export interface ChallengeDto {
  id: string;
  name?: string;
  location?: ChallengeLocationDto;
  description?: string;
  points?: number;
  imageUrl?: string;
  latF?: number;
  longF?: number;
  awardingRadiusF?: number;
  closeRadiusF?: number;
  linkedEventId?: string;
  timerLength?: number;
  scheduledStartTime?: string;
  scheduledEndTime?: string;
}

export interface RequestChallengeDataDto {
  challenges: string[];
}

export interface UpdateChallengeDataDto {
  challenge: ChallengeDto;
  deleted: boolean;
}

export interface RequestEventTrackerDataDto {
  trackedEvents: string[];
}

export interface SetCurrentChallengeDto {
  challengeId: string;
}

export interface RequestAvailableChallengesDto {}

export interface AvailableChallengesResponseDto {
  challenges: ChallengeDto[];
}

export interface LocationCheckInDto {
  campusEventId: string;
  latitude: number;
  longitude: number;
}

export interface QrCodeCheckInDto {
  qrCode: string;
}

export interface GenerateQrCodeDto {
  campusEventId: string;
}

export interface CheckInResultDto {
  attendanceId: string;
  campusEventId: string;
  checkInMethod: CheckInResultCheckInMethodDto;
  pointsAwarded: number;
  newTotalScore: number;
}

export interface CheckInErrorDto {
  message: string;
  code: CheckInErrorCodeDto;
}

export interface UpdateErrorDto {
  id: string;
  message: string;
}

export interface ClubSubmissionDto {
  clubName: string;
  contactEmail: string;
  eventTitle: string;
  description: string;
  startTime: string;
  endTime: string;
  location: string;
  latitude?: number;
  longitude?: number;
  category: ClubSubmissionCategoryDto;
  address?: string;
  imageUrl?: string;
  registrationLink?: string;
}

export interface RequestFilteredEventsDto {
  difficulty: string[];
  location: string[];
  category: string[];
  filterId: string[];
}

export interface RequestEventDataDto {
  events?: string[];
}

export interface RequestEventLeaderDataDto {
  offset: number;
  count: number;
  eventId?: string;
}

export interface LeaderDto {
  userId: string;
  username: string;
  score: number;
}

export interface UpdateLeaderDataDto {
  eventId?: string;
  offset: number;
  users: LeaderDto[];
}

export interface UpdateLeaderPositionDto {
  playerId: string;
  newTotalScore: number;
  newEventScore: number;
  eventId: string;
}

export interface RequestRecommendedEventsDto {
  latitudeF: number;
  longitudeF: number;
  count?: number;
}

export interface EventDto {
  id: string;
  requiredMembers?: number;
  name?: string;
  description?: string;
  longDescription?: string;
  category?: EventCategoryDto;
  imageUrl?: string;
  timeLimitation?: EventTimeLimitationDto;
  endTime?: string;
  challenges?: string[];
  userFavorites?: string[];
  initialOrganizationId?: string;
  difficulty?: EventDifficultyDto;
  indexable?: boolean;
  longitudeF?: number;
  latitudeF?: number;
  featured?: boolean;
  isJourney?: boolean;
  sortOrder?: number;
}

export interface PrevChallengeDto {
  challengeId: string;
  hintsUsed: number;
  extensionsUsed?: number;
  dateCompleted: string;
  failed?: boolean;
  dateExpired?: boolean;
}

export interface EventTrackerDto {
  eventId: string;
  isRanked: boolean;
  hintsUsed: number;
  curChallengeId?: string;
  prevChallenges: PrevChallengeDto[];
}

export interface UpdateEventTrackerDataDto {
  tracker: EventTrackerDto;
}

export interface UpdateEventDataDto {
  event: EventDto;
  deleted: boolean;
}

export interface UseEventTrackerHintDto {}

export interface TriggerEventSyncDto {
  days?: number;
}

export interface EventSyncResultDto {
  created: number;
  updated: number;
  archived: number;
  totalFetched: number;
  syncedAt: string;
}

export interface RequestEventSyncStatusDto {}

export interface UpdateEventSyncStatusDto {
  running: boolean;
  lastResult: EventSyncResultDto;
}

export interface SubmitFeedbackDto {
  category: FeedbackCategoryDto;
  text: string;
  rating?: boolean;
  challengeId?: string;
}

export interface FeedbackDto {
  id: string;
  createdAt: string;
  category: FeedbackCategoryDto;
  text: string;
  rating?: boolean;
  challengeId?: string;
  userId: string;
  username?: string;
  challengeName?: string;
}

export interface UpdateFeedbackDataDto {
  feedbacks: FeedbackDto[];
}

export interface JoinGroupDto {
  groupId: string;
}

export interface LeaveGroupDto {}

export interface RequestGroupDataDto {}

export interface SetCurrentEventDto {
  eventId: string;
}

export interface GroupMemberDto {
  id: string;
  name: string;
  points: number;
  curChallengeId?: string;
}

export interface GroupDto {
  id: string;
  friendlyId?: string;
  hostId?: string;
  curEventId?: string;
  members?: GroupMemberDto[];
}

export interface UpdateGroupDataDto {
  group: GroupDto;
  deleted: boolean;
}

export interface GroupInviteDto {
  groupId: string;
  username: string;
}

export interface SendGroupInviteDto {
  targetUsername: string;
}

export interface UpdatePushTokenDto {
  fcmToken: string;
}

export interface SendNotificationDto {
  title: string;
  body: string;
  userIds?: string[];
  organizationId?: string;
}

export interface NotificationResultDto {
  successCount: number;
  failureCount: number;
  errors?: string[];
}

export interface OrganizationDto {
  id: string;
  name?: string;
  accessCode?: string;
  members?: string[];
  events?: string[];
  managers?: string[];
  achivements?: string[];
}

export interface RequestOrganizationDataDto {
  admin: boolean;
}

export interface UpdateOrganizationDataDto {
  organization: OrganizationDto;
  deleted: boolean;
}

export interface RequestQuizQuestionDto {
  challengeId: string;
}

export interface ShuffleQuizQuestionDto {
  challengeId: string;
  currentQuestionId?: string;
}

export interface QuizAnswerDto {
  id?: string;
  answerText: string;
  isCorrect?: boolean;
}

export interface QuizQuestionDto {
  id: string;
  challengeId?: string;
  questionText?: string;
  explanation?: string;
  difficulty?: number;
  pointValue?: number;
  category?: string;
  answers?: QuizAnswerDto[];
}

export interface SubmitQuizAnswerDto {
  questionId: string;
  selectedAnswerId: string;
}

export interface QuizResultDto {
  isCorrect: boolean;
  pointsEarned: number;
  explanation?: string;
  correctAnswerText: string;
  newTotalScore: number;
}

export interface QuizProgressDto {
  challengeId: string;
  totalQuestions: number;
  answeredQuestions: number;
  remainingQuestions: number;
  isComplete: boolean;
  totalPointsEarned: number;
}

export interface QuizErrorDto {
  message: string;
  code: QuizErrorCodeDto;
}

export interface UpdateQuizQuestionDataDto {
  question: QuizQuestionDto;
  deleted: boolean;
}

export interface TimerStartedDto {
  timerId: string;
  endTime: string;
  challengeId: string;
  extensionsUsed: number;
}

export interface TimerExtendedDto {
  timerId: string;
  challengeId: string;
  newEndTime: string;
  extensionsUsed: number;
}

export interface TimerCompletedDto {
  timerId: string;
  challengeId: string;
  challengeCompleted: boolean;
}

export interface ExtendTimerDto {
  challengeId: string;
  endTime: string;
}

export interface StartChallengeTimerDto {
  challengeId: string;
}

export interface TimerWarningDto {
  challengeId: string;
  milestone: number;
  timeRemaining: number;
}

export interface ChallengeFailedDto {
  challengeId: string;
  userId: string;
}

export interface CloseAccountDto {}

export interface BanUserDto {
  userId: string;
  isBanned: boolean;
}

export interface SetAuthToOAuthDto {
  provider: SetAuthToOAuthProviderDto;
  authId: string;
}

export interface SetAuthToDeviceDto {
  deviceId: string;
}

export interface RequestGlobalLeaderDataDto {
  offset: number;
  count: number;
}

export interface RequestUserDataDto {
  userId?: string;
  hasCompletedOnboarding?: boolean;
}

export interface RequestAllUserDataDto {}

export interface RequestFavoriteEventDataDto {
  isFavorite: boolean;
  eventId: string;
}

export interface UserDto {
  id: string;
  username?: string;
  enrollmentType?: UserEnrollmentTypeDto;
  email?: string;
  year?: string;
  college?: string;
  major?: string;
  interests?: string[];
  score?: number;
  coins?: number;
  isBanned?: boolean;
  groupId?: string;
  authType?: UserAuthTypeDto;
  trackedEvents?: string[];
  favorites?: string[];
  hasCompletedOnboarding?: boolean;
}

export interface UpdateUserDataDto {
  user: UserDto;
  deleted: boolean;
}

export interface AddManagerDto {
  email: string;
  organizationId: string;
}

export interface JoinOrganizationDto {
  accessCode: string;
}

export interface CompleteOnboardingDto {}

export interface ResetOnboardingDto {}
